module.exports = __webpack_public_path__ + "img/2623.5a624b3.svg";